module.exports = __webpack_public_path__ + "static/TlwgTypewriter-Oblique-ff5c3f95988d3a9ff571dd2769dce2a1.woff2";